module.exports = __webpack_public_path__ + "gnarly-vines.63b994c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/images/neighborhood/full/gnarly-vines.jpg
// module id = 657
// module chunks = 0